import axios from 'axios';
import { CaseModel } from "app/edozvola/cases/cases.model";
import { FileWrapper } from 'app/shared/model/shared.model';
import { ValidationErrorState } from 'app/shared/reducers/validationerrors/validation-errors.reducer';
import { ActValidationErrorModel } from 'app/shared/reducers/validationerrors/model/validation-errors.model';

const caseBaseUrl = '/api/cases';

export const fetchCaseById = async (idCase: string): Promise<CaseModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/${idCase}`)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.error);
      });
  });
};

export const fetchCaseModerators = async (idCase: string): Promise<any> => {
  if (idCase) {
    return await new Promise((resolve, reject) => {
      axios
        .get(`${caseBaseUrl}/${idCase}/moderators`)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  }
};

export const delegateCase = async (idCase: string, idSolverCosolver: number): Promise<any> => {
  if (idCase) {
    return await new Promise((resolve, reject) => {
      axios
        .post(`${caseBaseUrl}/${idCase}/delegate/${idSolverCosolver}`)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  }
};

export const previewCaseActFile = async (idCaseAct): Promise<FileWrapper> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/case-acts/${idCaseAct}/preview-file`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const downloadCaseActFile = async (idCaseAct): Promise<FileWrapper> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/case-acts/${idCaseAct}/download-file`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const revalidateCaseActs = async (validationErrorState: ValidationErrorState): Promise<ActValidationErrorModel[]> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`${caseBaseUrl}/${validationErrorState?.idCase}/revalidate-case-acts`, validationErrorState?.actValidationErrors)
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};

export const canUserSeeCase = async (uuid: string) => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/${uuid}/check-case-permission`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.error));
  });
};

